import { router } from "@inertiajs/vue3"

import {
  verifyAuthenticationSessionPath,
  verifyAutocompleteAuthenticationSessionPath,
  verifyRegistrationSessionPath,
} from "@/routes"

export async function passkeyRegistration(
  credentialOptions: PublicKeyCredentialCreationOptionsJSON,
) {
  const publicKey =
    PublicKeyCredential.parseCreationOptionsFromJSON(credentialOptions)
  const credential = (await navigator.credentials.create({
    publicKey,
  })) as PublicKeyCredential

  return router.post(verifyRegistrationSessionPath(), credential.toJSON(), {
    preserveScroll: true,
  })
}

export async function passkeyAuthentication(
  credentialOptions: PublicKeyCredentialRequestOptionsJSON,
) {
  const credential = await navigatorCredentialsGet({
    publicKey:
      PublicKeyCredential.parseRequestOptionsFromJSON(credentialOptions),
  })

  if (!credential) throw new Error("No credential getted")

  return router.post(verifyAuthenticationSessionPath(), credential.toJSON(), {
    preserveScroll: true,
  })
}

export async function passkeyAutocomplete(
  credentialOptions: PublicKeyCredentialRequestOptionsJSON,
  abortController?: AbortController,
) {
  const credential = await navigatorCredentialsGet({
    publicKey:
      PublicKeyCredential.parseRequestOptionsFromJSON(credentialOptions),
    mediation: "conditional",
    signal: abortController?.signal,
  })

  if (!credential) throw new Error("No credential getted")
  else if (abortController?.signal.aborted) return

  return router.post(
    verifyAutocompleteAuthenticationSessionPath(),
    credential.toJSON(),
    { preserveScroll: true },
  )
}

async function navigatorCredentialsGet(options: CredentialRequestOptions) {
  return navigator.credentials.get(
    options,
  ) as Promise<PublicKeyCredential | null>
}
